import { InjectableClass } from '@fino/lib-injection';

export class TransferringService extends InjectableClass {
  constructor(ticketsService, TransferringStates) {
    'ngInject';
    super({ ticketsService, TransferringStates });
  }

  get states() {
    return this.TransferringStates;
  }

  getStateName(index) {
    return this.ticketsService.getStateName(index, this.states);
  }

  getStateIndex(state) {
    return this.ticketsService.getStateIndex(state, this.states);
  }

  nextState(state) {
    return this.ticketsService.nextState(state, this.states);
  }

  prevState(state) {
    return this.ticketsService.prevState(state, this.states);
  }
}
